import { CHROME_EXTENSION_URL } from '../constants/chromeExtension';
import { Mixpanel } from '../services/Mixpanel';

// The "Diffit for Chrome" plug, shared by the modals that point teachers at the
// extension (the YouTube transcript modal, the paste-a-link modal). Only the
// trailing clause differs per surface — the payoff is whatever copying and
// pasting the extension saves on that surface — so callers pass it as children.
//
// `source` is snake_case and names the surface, so one event covers every plug
// and still tells them apart in Mixpanel.
export const ChromeExtensionTip = ({ source, children }) => (
  <div className='flex items-center gap-3 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2.5'>
    {/* Decorative — the sentence beside it already names the extension.
        items-center on the row keeps it centered against the two lines. */}
    <span className='shrink-0 text-2xl leading-none' aria-hidden='true'>
      🧩
    </span>
    <p className='text-sm text-gray-700'>
      <span className='font-semibold'>Tip:</span> the{' '}
      <a
        href={CHROME_EXTENSION_URL}
        target='_blank'
        rel='noopener noreferrer'
        onClick={() => Mixpanel.track('Chrome Extension Tip Clicked', { source })}
        className='font-medium text-emerald-600 hover:text-emerald-700 underline'>
        Diffit for Chrome extension
      </a>{' '}
      {children}
    </p>
  </div>
);
